// @flow
import type { AppState } from '../../core/types'
import { createSelector } from 'reselect'
import { smembers, sisMember } from '../../modules/set'
import { getById } from '../../modules/entities'
import { domains } from '../constants'
import { BIDDING_SET } from './constants'
import { getAuctionItems, getEntity } from '../selectors'

export const isUserInterestedInItem = (itemId: number, state: AppState) => {
  return (
    sisMember(BIDDING_SET.WINNING, itemId, state) ||
    sisMember(BIDDING_SET.OUTBID, itemId, state)
  )
}

export const getBid = (bidId: number) => getById(domains.BIDS, bidId)
export const getWinningItemIds = smembers(BIDDING_SET.WINNING)
export const getOutbidItemIds = smembers(BIDDING_SET.OUTBID)
export const getWonItems = smembers(BIDDING_SET.WON)
export const getLostItems = smembers(BIDDING_SET.LOST)

export const getWinningItemsCount = createSelector(
  smembers(BIDDING_SET.WINNING),
  items => items.length
)

export const getOutbidItemsCount = createSelector(
  smembers(BIDDING_SET.OUTBID),
  items => items.length
)

export const getAuctionWonItems = (auctionId: number, state: AppState) => {
  const won = getWonItems(state)
  return getAuctionItems(auctionId, state).filter(i => won.includes(i.id))
}

export const getAuctionWonItemsNormalized = (
  auctionId: number,
  state: AppState
) =>
  getAuctionWonItems(auctionId, state).map(i =>
    getEntity(domains.ITEMS, i.id, state)
  )



// WEBPACK FOOTER //
// ./src/services/bid/selectors.js